import { ReactElement } from 'react';
import { ESSENTIALS_STEPS, SCALE_MIN_QUERIES } from '@sc/stripe/pricing';

const formatCountGb = (value: number): string =>
  value.toLocaleString('en-GB');

const firstStep = ESSENTIALS_STEPS[0];
const lastStep = ESSENTIALS_STEPS[ESSENTIALS_STEPS.length - 1];

export const ESSENTIALS_FROM_PRICE = `£${formatCountGb(
  firstStep?.priceGbp ?? 0
)}`;

// Feature bullets without the allowance range — for surfaces that already
// show the slider.
export const essentialsFeatures = [
  'Unlimited knowledge bases',
  'Unlimited users',
  '5 custom domains',
  'Query depth up to 3x',
  'Stark hosted URL',
  'Rate limits',
  'Access control',
];

export const essentialsList = [
  `${formatCountGb(firstStep?.queries ?? 0)} – ${formatCountGb(
    lastStep?.queries ?? 0
  )} queries / month`,
  `${formatCountGb(firstStep?.pages ?? 0)} – ${formatCountGb(
    lastStep?.pages ?? 0
  )} page imports / month`,
  'Scale your allowance on a slider',
  ...essentialsFeatures,
];

export const scaleList = [
  `From ${formatCountGb(SCALE_MIN_QUERIES)} queries / month`,
  'Custom page import volume',
  'Unlimited query depth',
  'Embed directly into your application with Stark Chat API',
  'Dedicated account manager',
];

export const Price = ({
  amount,
  suffix = '/mo',
}: {
  amount: string;
  suffix?: string;
}): ReactElement => (
  <p className="font-grotesque text-4xl leading-[1.22] lg:text-[3.75rem] lg:leading-15 font-normal text-white mb-6">
    {amount}
    {suffix && (
      <span className="text-text-low-priority text-base leading-6 align-baseline ml-2 font-normal">
        {suffix}
      </span>
    )}
  </p>
);
